import {
  Box,
  Typography,
  IconButton,
  AppBar,
  styled,
  Toolbar,
} from "@mui/material";
import React from "react";
import goola from "../assets/icons/goola.svg";
import goolaMobile from "../assets/icons/goolaMobile.svg";

function Header() {
  const StyleToolbar = styled(Toolbar)({
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "white",
    paddingBlock: 10,
  });
  return (
    <AppBar position="sticky">
      <StyleToolbar>
        <Typography
          variant="body2"
          sx={{
            color: "black",
            fontSize: 24,
            alignSelf: "center",
            display: { xs: "none", sm: "block" },
          }}
        >
          {/* חייגו 03-6366066 */}
        </Typography>
        <IconButton>
          {/* <a href="tel:+9720543366250">
            <Box
              component="img"
              src={phone}
              sx={{ display: { xs: "block", sm: "none" } }}
            />
          </a> */}
        </IconButton>
        <Box
          component="img"
          sx={{
            content: {
              xs: `url(${goolaMobile})`, //img src from xs up to md
              md: `url(${goola})`, //img src from md and up
            },
          }}
        />
      </StyleToolbar>
    </AppBar>
  );
}

export default Header;
